// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3Xwu0","footer":"ChangeClinic_footer__1ZQiH"};